import { render, staticRenderFns } from "./ReposTable.vue?vue&type=template&id=f0389c5e&scoped=true&"
import script from "./ReposTable.vue?vue&type=script&lang=ts&"
export * from "./ReposTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReposTable.vue?vue&type=style&index=0&id=f0389c5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0389c5e",
  null
  
)

export default component.exports